import { CroustilleElement } from '../lib'
import Cookies from 'js-cookie'

class MobileNavigation extends CroustilleElement {
  constructor() {
    super('mobile-navgiation')
  }

  get toggle() {
    return this.querySelector('[data-mobile-navigation-toggle]')
  }

  get content() {
    return this.querySelector('[data-mobile-navigation-content]')
  }

  toggleHandler() {
    if (this.active) {
      this.content.style.display = 'none'
    } else {
      this.content.style.display = 'block'
    }
    this.active = !this.active
  }

  init() {
    this.active = false
    this.toggleHandler = this.toggleHandler.bind(this)
    this.toggle.addEventListener('click', this.toggleHandler)
  }
}

export default MobileNavigation
